import { CardInfoModule } from './cardInfo/cardInfo';
import { CreditCardEditorModule } from './creditCardEditor/creditCardEditor.module';
import { FormatCcExpirationModule } from './formatCcExpiration.directive';
import { ValidateCcExpirationModule } from './validateCcExpiration.directive';

export const CreditCardsModule = angular
    .module('app.components.creditCards', [
        CardInfoModule,
        CreditCardEditorModule,
        FormatCcExpirationModule,
        ValidateCcExpirationModule
    ]).name;


// WEBPACK FOOTER //
// ./src/app/components/creditCards/creditCards.module.js